(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('TravelExpensesListController', TravelExpensesListController);

    TravelExpensesListController.$inject = ['$state', '$uibModal', 'toastr', 'CitiesByExpoService', 'TravelExpenseService', 'ExpoService', 'SellerService', 'EventsService', 'expenseTypeList', 'paymentTypeList', '$stateParams', 'CurrentUser'];

    function TravelExpensesListController($state, $uibModal, toastr, CitiesByExpoService, TravelExpenseService, ExpoService, SellerService, EventsService, expenseTypeList, paymentTypeList, $stateParams, CurrentUser) {
        var vm = this;
        vm.datePicker = {
            "autoApply": true
        };
        vm.expenseTypeSelected = {};
        vm.expenseTypeList = expenseTypeList;
        vm.paymentTypeSelected = {};
        vm.paymentTypeList = paymentTypeList;
        vm.statementLinked = -1;
        vm.hasReceipt = [{
            id: -1,
            name: '--- All ---'
        }, {
            id: 1,
            name: 'Yes'
        }, {
            id: 0,
            name: 'No'
        }];
        vm.hasReceiptSelected = -1;
        vm.dateOptions = {
            locale: {
                format: 'MM/DD/YYYY',
                cancelLabel: 'Close'
            }
        };
        vm.selectOptionAll = [{
            name: '--- All ---',
            id: -1
        }];
        vm.description = '';
        vm.expenseDate = {};
        vm.expoSelected = {};
        vm.citySelected = {};
        vm.othersEventsSelected = {};
        vm.othersEventsList = [];
        vm.cities = [];
        vm.expos = [];
        vm.query = [];
        vm.expenses = [];
        vm.sellers = [];
        vm.sellerSelected = '';
        vm.templateUrl = '';
        vm.isApprovedSelected = -1;
        vm.isApproved = [{
                id: -1,
                name: '-- All --'
            },
            {
                id: 1,
                name: 'Yes'
            },
            {
                id: 0,
                name: 'No'
            }
        ];
        vm.convertToUTC = convertToUTC;
        vm.getOthersEvents = getOthersEvents;
        vm.selectExpo = selectExpo;
        vm.loadSellers = loadSellers;
        vm.selectCitiesByExpo = selectCitiesByExpo;
        vm.getByFilter = getByFilter;
        vm.deleteTravelExpense = deleteTravelExpense;
        vm.viewTravelExpense = viewTravelExpense;
        vm.clearFilter = clearFilter;
        vm.pendingSharedExpenses = pendingSharedExpenses;
        vm.getExpenseForView = getExpenseForView;
        vm.goToEdit = goToEdit;

        /*PAGINATION*/
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.totalItems = [];
        vm.to = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.paymentTypeList.unshift({
                name: '--- All ---',
                id: 'all'
            });
            vm.expenseTypeList.unshift({
                name: '--- All ---',
                id: 'all'
            });
            vm.loadSellers();
            vm.getByFilter();
            vm.selectExpo();
            vm.pendingSharedExpenses();
            vm.getExpenseForView();
        }

        function getExpenseForView() {
            if (typeof $stateParams.expenseId !== 'undefined') {
                vm.query = {};
                vm.query['id'] = $stateParams.expenseId;
                TravelExpenseService.editExpense(vm.query).then(function (response) {
                    vm.viewTravelExpense(response.data);
                }).catch(function (err) {});
            }

        }

        function convertToUTC(date) {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        function getOthersEvents() {
            EventsService.getOthersEvents().then(function (response) {
                vm.othersEventsList = response.data;
            });
        }

        function loadSellers() {
            SellerService.getStaff().then(function (response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function (err) {});
        }

        function selectExpo() {
            ExpoService.getExpos().then(function (response) {
                vm.expos = response.data;
            }).catch(function (err) {});
        }

        function selectCitiesByExpo() {
            vm.citySelected = {};
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function (response) {
                vm.cities = response.data;
                vm.cities.unshift({
                    location_id: -1,
                    city_name: '-- All --'
                });
                vm.citySelected = {
                    location_id: -1,
                    city_name: '-- All --'
                };
                if (vm.expense) {
                    vm.citySelected = $filter('filter')(vm.cities, {
                        expos_locations_id: vm.expense.expo_location_id
                    })[0];
                }
            }).catch(function (err) {});
        }

        function getByFilter() {
            var query = {};

            if (TravelExpenseService.filters) {
                vm.expenseDate = TravelExpenseService.filters.expenseDate;
                vm.expoSelected = TravelExpenseService.filters.expoSelected;
                vm.citySelected = TravelExpenseService.filters.citySelected;
                vm.othersEventsSelected = TravelExpenseService.filters.othersEventsSelected;
                vm.filePath = TravelExpenseService.filters.filePath;
                vm.picture = TravelExpenseService.filters.picture;
                vm.selectedCurrency = TravelExpenseService.filters.selectedCurrency;
                vm.value = TravelExpenseService.filters.value;
                vm.description = TravelExpenseService.filters.description;
                vm.expenseTypeSelected = TravelExpenseService.filters.expenseTypeSelected;
                vm.paymentTypeSelected = TravelExpenseService.filters.paymentTypeSelected;
                vm.sellerSelected = TravelExpenseService.filters.sellerSelected;
                vm.isApprovedSelected = TravelExpenseService.filters.isApprovedSelected;
                vm.page = TravelExpenseService.filters.page;
                vm.hasReceiptSelected = TravelExpenseService.filters.hasReceiptSelected;
                vm.statementLinked = TravelExpenseService.filters.statementLinked;
            }

            TravelExpenseService.filters = null;

            if (typeof vm.expenseDate.startDate !== 'undefined' && typeof vm.expenseDate.endDate !== 'undefined') {
                query['start_date'] = vm.convertToUTC(new Date(vm.expenseDate.startDate));
                query['end_date'] = vm.convertToUTC(new Date(vm.expenseDate.endDate));
            }
            if (typeof vm.expoSelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if (typeof vm.citySelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event' && vm.citySelected.location_id > -1) {
                query['location_id'] = vm.citySelected.location_id;
            }
            if (typeof vm.othersEventsSelected !== 'undefined' && vm.othersEventsSelected.id !== 'other_event') {
                query['other_event_id'] = vm.othersEventsSelected.id;
            }
            if (typeof vm.filePath !== 'undefined' && vm.filePath !== '') {
                query['file_path'] = vm.filePath;
            }
            if (typeof vm.picture !== 'undefined' && vm.picture !== '') {
                query['file_path'] = vm.picture;
            }
            if (typeof vm.selectedCurrency !== 'undefined' && vm.selectedCurrency !== '') {
                query['currency'] = vm.selectedCurrency.code;
            }
            if (typeof vm.value !== 'undefined' && vm.value !== '') {
                query['value'] = vm.value;
            }
            if (vm.description !== '') {
                query['description'] = vm.description;
            }
            if (typeof vm.expenseTypeSelected !== 'undefined' && vm.expenseTypeSelected.id !== 'all') {
                query['type'] = vm.expenseTypeSelected.id;
            }
            if (typeof vm.paymentTypeSelected !== 'undefined' && vm.paymentTypeSelected.id !== 'all') {
                query['payment_type'] = vm.paymentTypeSelected.id;
            }
            if (typeof vm.sellerSelected !== 'undefined') {
                query['seller_id'] = vm.sellerSelected.id;
            }
            if (vm.statementLinked > -1) {
                query['linked'] = vm.statementLinked;
            }
            if (vm.hasReceiptSelected > -1) {
                query['has_receipt'] = vm.hasReceiptSelected;
            }
            query['is_approved'] = vm.isApprovedSelected;
            query['page'] = vm.page;

            TravelExpenseService.getExpense(query).then(function (response) {
                vm.expenses = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function (err) {});
        }

        function deleteTravelExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/deleteExpense/template.modal.html',
                controller: 'DeleteTravelExpensesController',
                controllerAs: 'DeleteExpense',
                resolve: {
                    expense: function () {
                        return expense;
                    },
                    expensesList: function () {
                        return vm.expenses;
                    }
                }
            });
        }

        function viewTravelExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/viewTravelExpenseModal/viewTravelExpenseModal.html',
                controller: 'ViewTravelExpenseModalController',
                controllerAs: 'ViewTravelExpenseModal',
                resolve: {
                    expense: function () {
                        return expense;
                    },
                    expenseTypeList: function () {
                        return vm.expenseTypeList;
                    },
                    paymentTypeList: function () {
                        return vm.paymentTypeList;
                    },
                    user: function () {
                        return CurrentUser;
                    }

                }
            });
        }

        function clearFilter() {
            TravelExpenseService.filters = null;

            vm.expenseDate = {};
            vm.expenseTypeSelected = {};
            vm.description = '';
            vm.paymentTypeSelected = {};
            vm.sellerSelected = '';
            vm.expoSelected = '';
            vm.isApprovedSelected = -1;
            vm.statementLinked = -1;
        }

        function goToEdit(expense) {
            let params = {
                expenseId: expense.id
            };

            TravelExpenseService.setFilters(vm);
            $state.go("root.travel_expenses.edit", params);
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged(pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function pendingSharedExpenses() {
            TravelExpenseService.getPendingSharedExpenses(CurrentUser.id).then(function (response) {
                vm.pendingSharedExpenses = response.data;
                if (vm.pendingSharedExpenses.length) {
                    $uibModal.open({
                        templateUrl: 'templates/travelexpenses/pendingSharedExpenses/viewPendingSharedExpenses.modal.html',
                        controller: 'ViewPendingSharedExpensesController',
                        controllerAs: 'vm',
                        resolve: {
                            pendingSharedExpenses: function () {
                                return vm.pendingSharedExpenses;
                            },
                            expenseTypeList: function () {
                                return vm.expenseTypeList;
                            },
                            paymentTypeList: function () {
                                return vm.paymentTypeList;
                            }
                        }
                    });
                }
            });
        }


        activate();
    }

})();